import React, { useEffect, useState } from 'react';
import { Table, Input, Row, Col, Button } from 'antd';
import './commonTable.scss';

export interface SortedInfo {
    columnKey: string,
    order: string
}
let constAllowDeletedData: boolean;
// sort order no 
// ellipsis
// change search style && test functionality
// change sort
// fixed: 'right' ???
const sortData = (tableData, columnKey) => {
    if (constAllowDeletedData && columnKey == 'date') {
        tableData.sort(function (a: any, b: any) {
            return (+b.dateNumber - +a.dateNumber);
        });
    } else {
        tableData.sort(function (a: any, b: any) {
            return b[columnKey].localeCompare(a[columnKey]);
        });
    }
}
const CommonTable = ({ tableRowdata, columns, tableConfig, showDeletedInvoices, allowDeletedData, changeDateInvoices, addBtnString, btnCallFunc }: any) => {
    const [tableData, setTableData] = useState([...tableRowdata]);
    constAllowDeletedData = allowDeletedData;
    useEffect(() => {
        if (tableRowdata.length && tableConfig.descSortKey) {
            sortData(tableRowdata, tableConfig.descSortKey);
        }
        setTableData([...tableRowdata]);
    }, [tableRowdata]);
    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
        if (sorter.column && sorter.column.sorter) {
            if (sorter.order === 'ascend') {
                if (constAllowDeletedData && sorter.columnKey == 'date') {
                    tableData.sort(function (a: any, b: any) {
                        return (+a.dateNumber - +b.dateNumber);
                    });
                } else {
                    tableData.sort(function (a: any, b: any) {
                        return a[sorter.columnKey].localeCompare(b[sorter.columnKey]);
                    });
                }

            } else {
                tableData.reverse();
            }
        } else {
            if (!sorter.column) {
                setTableData([...tableRowdata]);
            }
        }
    }
    const handleSearchChange = ({ target: { value } }) => {
        const newValue = value.toLowerCase();
        setTableData(tableRowdata.filter((eachRowData: any) => {
            for (let key in eachRowData) {
                if (key !== 'key' && typeof eachRowData[key] === 'string' && eachRowData[key]?.toLowerCase().includes(newValue)) {
                    return eachRowData;
                }
            }
            return;
        }
        ))
    }
    return (
        <>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32, xl: 32 }}>
                <Col className="gutter-row" xs={{ span: 8 }} >
                    <Button type="primary" onClick={btnCallFunc}>
                        {addBtnString}
                    </Button>
                </Col>
                <Col className="gutter-row" xs={{ span: 8, offset: 4 }} style={{float: 'right'}} >
                    {
                        allowDeletedData ?
                            <>
                                <Button type="primary" ghost onClick={changeDateInvoices}>
                                    {showDeletedInvoices ? 'Show Live Invoices' : 'Show Deleted Invoices'}
                                </Button>
                            </> :
                            <> </>
                    }
                </Col>
                <Col className="gutter-row" xs={{ span: 4}}>
                    <Input autoComplete="off" className="search_bar" onChange={e => handleSearchChange(e)} placeholder="Search" />
                </Col>
            </Row>
            <Table
                {...tableConfig}
                //   sortDirections={sortDir}
                pagination={{ position: ['bottomRight'], pageSize: 10 }}
                columns={columns}
                dataSource={tableData}
                scroll={{ x: 300 }}
                onChange={handleTableChange}
            />
        </>
    );
}

export default CommonTable;